import {useQuery} from "@apollo/client";
import {
  IonItem,
  IonRadio,
  IonLabel,
  IonRadioGroup,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonItemDivider,
} from "@ionic/react";
import dayjs from "dayjs";
import {useForm} from "react-hook-form";
import {useEffect, useState} from "react";

import {Accordion, DatePicker, Input, Select} from "../../../components";
import {
  GET_DYLOG_COMPANY_TYPES,
  GET_DYLOG_DOCUMENT_TYPES,
  GET_DYLOG_FOREIGN_COUNTRIES,
  GET_DYLOG_MUNICIPALITIES,
  GET_DYLOG_PROVINCES,
  GET_DYLOG_TYPONYMS,
} from "../../../graphql/queries/dylog.query";

import "./carrello.style.css";
import SelectWithSearch from "../../../components/SelectWithSearch";

interface ICarrelloProps {
  stepSubmit: any;
  initialValues?: any;
  orderData?: any;

  formFields?: any;
}

export default function Carrellointestatario(props: ICarrelloProps) {
  const {
    register,
    handleSubmit,
    control,
    formState: {errors},
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm();

  const [selected, setSelected] = useState("client");

  const [typonymList, setTyponymList] = useState<any[]>([]);
  const [provinceList, setProvinceList] = useState<any[]>([]);
  const [companyTypes, setCompanyTypes] = useState<any[]>([]);
  const [documentTypes, setDocumentTypes] = useState<any[]>([]);
  const [municpalityList, setMunicipalityList] = useState<any[]>([]);
  const [foreignCountries, setForeignCountries] = useState<any[]>([]);

  const billToValues = [
    {
      name: "Me",
      value: "client",
    },
    {
      name: "intestatario della pratica",
      value: "accountHolder",
    },
    {
      name: "Altro (da specificare)",
      value: "other",
    },
  ];

  //
  useQuery(GET_DYLOG_MUNICIPALITIES, {
    onCompleted(data) {
      const actualData = data?.getPaginatedMunicipalities?.data ?? [];
      setMunicipalityList(
        actualData.map((itm: any) => ({
          value: itm.id,
          display: itm.description,
        }))
      );
    },
  });

  useQuery(GET_DYLOG_PROVINCES, {
    onCompleted(data) {
      const actualData = data?.getPaginatedProvinces?.data ?? [];
      setProvinceList(
        actualData.map((itm: any) => ({
          value: itm.id,
          display: itm.description,
        }))
      );
    },
  });

  useQuery(GET_DYLOG_COMPANY_TYPES, {
    onCompleted(data) {
      const actualData = data?.getCompanyTypes?.data ?? [];
      if (!actualData.length) return;

      setCompanyTypes(
        actualData.map((item: any) => ({
          value: item.id,
          display: item.description,
        }))
      );
    },
  });

  useQuery(GET_DYLOG_FOREIGN_COUNTRIES, {
    onCompleted(data) {
      const actualData = data?.getPaginatedForeignCountries?.data ?? [];
      if (!actualData.length) return;

      setForeignCountries(
        actualData.map((item: any) => ({
          value: item.id,
          display: item.description,
        }))
      );
    },
  });

  useQuery(GET_DYLOG_TYPONYMS, {
    onCompleted(data) {
      const actualData = data?.getPaginatedTyponyms?.data ?? [];
      if (!actualData.length) return;

      setTyponymList(
        actualData.map((item: any) => ({
          value: item.id,
          display: item.description,
        }))
      );
    },
  });

  useQuery(GET_DYLOG_DOCUMENT_TYPES, {
    onCompleted(data) {
      const actualData = data?.getDocumentTypes?.data ?? [];
      if (!actualData.length) return;

      setDocumentTypes(
        actualData.map((item: any) => ({
          value: item.id,
          display: item.description,
        }))
      );
    },
  });

  //
  const onSubmit = (data: any) => {
    props.stepSubmit({
      accountHolder: data.accountHolder,
      billingAddress: data.billingAddress ?? {},
      note: data.note,
      billTo: selected,
    });
  };

  //
  const username = props.orderData?.accHolder?.name;

  //
  useEffect(() => {
    Object.entries(props.initialValues ?? {}).forEach(([objKey, objValue]) => {
      setValue(objKey, objValue);
    });
    if (props.initialValues?.billTo) setSelected(props.initialValues.billTo);
  }, [props.initialValues]);

  useEffect(() => {
    const isAccHolder = selected === "accountHolder";
    const agencyData = props.orderData?.accHolder;

    //
    setValue(
      "billingAddress.fiscalCode",
      isAccHolder ? agencyData?.fiscalCode : null
    );
    setValue(
      "billingAddress.vatNumber",
      isAccHolder ? agencyData?.vatNumber : null
    );
    setValue(
      "billingAddress.companyName",
      isAccHolder ? agencyData?.businessName : null
    );
    setValue(
      "billingAddress.streetNumber",
      isAccHolder ? agencyData?.houseNumber : null
    );
    setValue(
      "billingAddress.postalCode",
      isAccHolder ? agencyData?.postalCode : null
    );
    setValue(
      "billingAddress.address",
      isAccHolder ? agencyData?.address : null
    );
    setValue("billingAddress.email", isAccHolder ? agencyData?.email : null);
    setValue(
      "billingAddress.pecEmail",
      isAccHolder ? agencyData?.pecEmail : null
    );
    setValue(
      "billingAddress.cityId",
      isAccHolder ? agencyData?.municipalityId : null
    );
    setValue(
      "billingAddress.provinceId",
      isAccHolder ? agencyData?.province : null
    );
    setValue(
      "billingAddress.companyTypeId",
      isAccHolder ? agencyData?.companyTypeId : null
    );
    setValue(
      "billingAddress.regionId",
      isAccHolder ? agencyData?.regionId : null
    );
    setValue(
      "billingAddress.streetId",
      isAccHolder ? agencyData?.streetId : null
    );
    setValue(
      "billingAddress.documentTypeId",
      isAccHolder ? agencyData?.documentTypeId : null
    );
    setValue(
      "billingAddress.documentNumber",
      isAccHolder ? agencyData?.documentNumber : null
    );
    setValue(
      "billingAddress.documentExpiryDate",
      isAccHolder
        ? agencyData?.expiresAt
          ? dayjs(new Date(+agencyData?.expiresAt)).format("YYYY-MM-DD")
          : null
        : null
    );
  }, [selected, props.orderData]);

  //
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="carrello-flex-body">
      {username && (
        <div style={{margin: "1rem 0"}}>
          <IonLabel>
            Denominazione società / nominativo persona fisica:
          </IonLabel>
          <input
            disabled
            value={username}
            className="app-input-field app-input-field-disabled"
            style={{marginTop: "0.5rem"}}
          />
        </div>
      )}

      {/*  */}
      <div>
        <Accordion title="Fatture pratiche a:">
          <IonRadioGroup
            className="display-flex pratiche-item-section"
            value={selected}
            onIonChange={(e) => setSelected(e.detail.value)}
          >
            {billToValues.map((option, i) => (
              <IonItem key={i}>
                <IonLabel>{option.name}</IonLabel>
                <IonRadio
                  slot="start"
                  value={option.value}
                  className="checkbox-fix"
                />
              </IonItem>
            ))}
          </IonRadioGroup>
          <IonGrid>
            <IonItemDivider className="carrrello-divider" />

            {selected !== "client" && (
              <>
                <IonRow>
                  {selected !== "accountHolder" && (
                    <IonCol size="12" size-sm="6">
                      <Input
                        name="Intestatario fattura"
                        registerName="billingAddress.invoiceHolder"
                        register={register}
                        errors={errors}
                        required
                      />
                    </IonCol>
                  )}

                  <IonCol size="12" size-sm="6">
                    <Input
                      name="Intestatario"
                      registerName="billingAddress.companyName"
                      register={register}
                      errors={errors}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <Input
                      name="Codice fiscale"
                      registerName="billingAddress.fiscalCode"
                      register={register}
                      errors={errors}
                      required
                      requiredMessage="Il codice fiscale è obbligatorio"
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <Input
                      name="Partita IVA"
                      registerName="billingAddress.vatNumber"
                      register={register}
                      errors={errors}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <Input
                      name="Email"
                      registerName="billingAddress.email"
                      register={register}
                      errors={errors}
                      pattern={{
                        value: /^[\w.]+@([\w-]+\.)+[\w-]{2,3}$/i,
                        message: "Formato non corretto",
                      }}
                      required
                      requiredMessage="L'email è obbligatoria"
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <Input
                      name="PEC"
                      registerName="billingAddress.pecEmail"
                      register={register}
                      errors={errors}
                      pattern={{
                        value: /^[\w.]+@([\w-]+\.)+[\w-]{2,3}$/i,
                        message: "Formato non corretto",
                      }}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <Select
                      name="Tipo società"
                      registerName={`billingAddress.companyTypeId`}
                      register={register}
                      errors={errors}
                      options={companyTypes}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <SelectWithSearch
                      name="Toponimo"
                      registerName={`billingAddress.streetId`}
                      register={register}
                      errors={errors}
                      options={typonymList}
                      requiredMessage="Il toponimo è obbligatorio"
                      setValue={setValue}
                      getValues={getValues}
                      watch={watch}
                      clearErrors={clearErrors}
                      hasSearch={true}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <Input
                      name="Via"
                      registerName="billingAddress.address"
                      register={register}
                      errors={errors}
                      required
                      requiredMessage="La via è obbligatoria"
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <Input
                      name="N°"
                      registerName="billingAddress.streetNumber"
                      register={register}
                      errors={errors}
                      required
                      requiredMessage="Il numero è obbligatorio"
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <SelectWithSearch
                      name="Città"
                      registerName={`billingAddress.cityId`}
                      register={register}
                      errors={errors}
                      options={municpalityList}
                      requiredMessage="La città è obbligatoria"
                      setValue={setValue}
                      getValues={getValues}
                      watch={watch}
                      clearErrors={clearErrors}
                      hasSearch={true}
                      required
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <SelectWithSearch
                      name="Provincia"
                      registerName={`billingAddress.provinceId`}
                      register={register}
                      errors={errors}
                      options={provinceList}
                      setValue={setValue}
                      getValues={getValues}
                      watch={watch}
                      clearErrors={clearErrors}
                      hasSearch={true}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="6">
                    <SelectWithSearch
                      name="Stato"
                      registerName={`billingAddress.regionId`}
                      register={register}
                      errors={errors}
                      options={foreignCountries}
                      setValue={setValue}
                      getValues={getValues}
                      watch={watch}
                      clearErrors={clearErrors}
                      hasSearch={true}
                    />
                  </IonCol>
                </IonRow>
              </>
            )}
          </IonGrid>
        </Accordion>
      </div>

      <div className="carrello-bb">
        <IonButton
          shape="round"
          slot="end"
          size="default"
          className="submit-button"
          type="submit"
        >
          Conferma
        </IonButton>
      </div>
    </form>
  );
}
